import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

const Container = ({ style, ...props }: BoxProps) => {
  const isMobile = useIsMobileBreakpoint();

  return <Box {...props} style={[styles.container, !isMobile && styles.containerDesktop, style]} />;
};

interface IMoreOptions {
  openFilterModal: () => void;
  buttonText: string;
}
export const MoreOptions: React.FC<React.PropsWithChildren<IMoreOptions>> = ({
  openFilterModal,
  buttonText,
}) => {
  return (
    <Container>
      <Typography
        fontFamily="heading"
        fontSize="sm"
        onPress={openFilterModal}
        accessibilityRole="button"
      >
        {buttonText}
      </Typography>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginVertical: spacing.$0,
    padding: 0,
    paddingTop: spacing.$6,
  },
  containerDesktop: {
    marginVertical: spacing.$2,
    paddingBottom: spacing.$4,
    paddingLeft: spacing.$1,
    paddingRight: 0,
    paddingTop: 0,
  },
});
